import { Component } from '@angular/core';
import { ViolationTooltipData } from '../../model/violation-tooltip-data';

@Component({
  selector: 'app-violation-tooltip',
  templateUrl: './violation-tooltip.component.html',
  styleUrls: ['./violation-tooltip.component.scss']
})
export class ViolationTooltipComponent {

  data: ViolationTooltipData;

}
